'use strict';

angular.module('far.gallery', ['angularFileUpload', 'dndLists']);